import { Field } from '@smartsoftware/reflex-core';
import { DexResourceModel } from '../abstracts/dexResource.model';

export class Service extends DexResourceModel {
   
    @Field(String)
	public name: string = "";
    @Field(Boolean)
	public showAdvanceFeesCheckBox?: Boolean = true;
    @Field(Boolean)
	public showAlwaysDeliverCourtesyFeesBackCheckBox?: Boolean = true;
    @Field(Boolean)
	public showFirstAppearanceFeesCheckBox?: Boolean = true;
    @Field(String)
    public displayName: string | null = null;
    @Field(String)
    public code?: string = "";
    @Field(Date)
    public createdAt: Date = new Date();
	@Field(Date)
	public updatedAt: Date = new Date();
    @Field(Date)
	public deletedAt: Date | null = null;
    
    constructor(data?: any) {
        super();
        this.mapData(data);
    }

    public get data(): any {
        let json = super.data;

        return json;
    }

}
